import { renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["PopoverPortal"], null, {
        default: _withCtx(() => [
            _createVNode($setup["PopoverContent"], _mergeProps($setup.forwarded, {
                "data-slot": "popover-content",
                class: $setup.cn('bg-popover text-popover-foreground z-2500 w-auto rounded-lg border shadow-md outline-none', 'data-[state=open]:animate-in data-[state=closed]:animate-out', 'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', 'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95', 'data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2', 'data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2', $setup.props.class)
            }), {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3 /* FORWARDED */
            }, 16 /* FULL_PROPS */, ["class"])
        ]),
        _: 3 /* FORWARDED */
    }));
}
